import React, { Component } from 'react'
import { connect } from 'react-redux'
import './doorKey.css'
import { setDoorKeyNotificaionPage, setCallKeyclick, setQRScannerPage, setLoadingMass, setErrorPopDoorKey, validateReservationNo, validateDigitalKey, getDigitalKeySupportedAuthMethods, currentWidget, setDigitalKeySupportedAuthMethods, setFeatureNotAvailOnWeb,setShowCustomPopup } from '../../action/action'
import { popupOpenClose } from '../../action/action'
import { bluetoothCheckMsg,  globalSalt, globalIV, CLICKED, EXIT, WEB_VERSION_ENABLED, CMSPath, } from '../../config/constant'
import { setRegPage } from '../../action/action'
//import { startScanner } from './QRScanner'
import { QRSCANENABLE, DEMO, VERIFY_THROUGH_CMS } from '../../config/constant'
import { HashRouter,Redirect } from 'react-router-dom';
import ErrorScreen from './mobileKeyOverlay';
import { AesUtil } from '../../JS/AesUtil';
import ErrorPop from './errorPop'
import runRequestPermission from '../../layout2.0/JS/runRequestPermission'
import Loader from "../../layout2.0/UI/loader"
import { setLoader, setLoginRequired, setGoHome, setCustomTextForLoginPopup } from "../../layout2.0/action/homeAction"
import { booleanConditionCheck, getDefaultAnalyticsLabel, toBool } from "../../layout2.0/JS/utility"
import axios from 'axios'
import {setSuccessFailPop} from  '../../layout2.0/action/viewBillAction2'
import { setLoaderClosed } from '../../layout2.0/action/homeAction'
import { sendAnalytics } from "../../action/homeAction"
import DoorKeyStepsGuide from './doorKeyStepsGuide'
import { setDoorKeyGuide } from '../../action/homeAction'
import OtpValidation from './otpValidation'
import MobileKeyOverlay from './mobileKeyOverlay'
import { withTranslation } from 'react-i18next'

// window.runAfterLocationPermissionsCheck = (key) => {
//     try {
//         console.log("runAfterLocationPermissionsCheck being called");
//         window.doorKey.locationPermissionCallback(key, window.doorKey);
//     }catch (e) {
//         console.log("error while tring to call runAfterLocationPermissionsCheck from Native:", e);
//         if(window.FireBasePlugin){
//             // window.FirebasePlugin.logMessage("error messege");
//             window.FirebasePlugin.logError("error while tring to call runAfterLocationPermissionsCheck from Native:" + e)
//           }
//     }
// };

class DoorKey extends Component {

    constructor(props){
        super(props);
        this.state = {
            showRoomDoorPage:false,
            showErrScreen:false,
            locationId: this.props.guestDetail.locationId,
            token: localStorage.getItem("GuestJourneySessionToken"),
            reservationNumber: null,
            isUserVerified: false,
            locationPopupShown: false,
            showLoader: true,
            validateKeyResponse: false,
            showGuide: true,
            apiCalled: false,
            showValidationOption: false,
            showLocationErrScreen: false,
            showBluetoothErrScreen: false,
            showCameraErrScreen: false,
            qrScanRequired: this.props.digitalKeySupportedAuthMethods.includes("QRonTV") || this.props.digitalKeySupportedAuthMethods.includes("QRshare"),
            errorSource: "",
            guestDetailsNotFound: false,
            showNotificationErrScreen: false,
        }
        // window.compRef = this;
        this.validateKeyCancelToken = axios.CancelToken
        this.cancelValidateKeySource = this.validateKeyCancelToken.source();
        this.loaderTimer = null;
        this.noOfAttemptsValidateGuest = 0;
        this.nuOfAttemptsQRScan = 0;
        this.apiTimer = null;
        this.errorInIOSLocation = true;
        this.t=this.props.t;
        window.doorKey = this
    }

    sendGAEvent = (action, message, callback, extraLabelInfo) => {
        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        
        this.props.sendAnalytics(
            this.props.guestDetail, 
            "Digital Door Key",
            action, 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget",  "pageName": "NATIVE PERMISSIONS", "errorMessage": message && message, "widgetSessionId": localStorage.getItem("doorKeySessionToken"), ...extraLabelInfo},
            0, 
            this.props.guestIsLoggedIn,
            callback ? callback : false
        );
    }


    keyClick = async() => {

        const room = localStorage.getItem("room");
        let guestDetails = localStorage.getItem("Guest_Details")
        let token = localStorage.getItem('GuestJourneySessionToken');

        if(WEB_VERSION_ENABLED && !DEMO){
            this.props.setFeatureNotAvailOnWeb({"enablePopup": true, "featureName": "Door Key"})
            return;
        } else {
        if(!room || room == "null"){
            if(process.env.REACT_APP_INROOMTAB == "true") {
                
                this.props.setLoginRequired(true)
            } else {
                this.props.setRegPage(true);
            }
            
            this.props.setCustomTextForLoginPopup({
                topHeading:this.t("login_popup.room_key.topHeading"),
                warning:this.t("login_popup.room_key.warning"),
                heading:this.t("login_popup.room_key.heading"),
                subHeading:this.t("login_popup.room_key.subHeading"),
                primaryButtonText:this.t("login_popup.room_key.primaryButtonText"),
                
            })
            return;
        }}

        this.sendGAEvent(CLICKED, "");
        if(this.props.callKeyclick){
            this.props.setCallKeyclick(false);
            if (DEMO) {
                this.setState({ showRoomDoorPage: true });
                return;
            }
            this.callForPermission()
            return;
        }

        if (process.env.REACT_APP_ENABLE_OTP_FLOW == "true") {
            
            if(localStorage.getItem("VerifiedUser") == "true" || this.props.skipDigitalKeyValidation){
                this.props.setLoader(true, "Checking required permissions...")
            } else {
                this.props.setLoader(true, "Getting the auth options...")
            }

            if (guestDetails) {
                if (localStorage.getItem("VerifiedUser") == "true") {
                    this.props.setLoader(false, "")

                    if (localStorage.getItem("DoorKeyGuideShown") != "true") {
                        this.props.setDoorKeyGuide(true)
                    } else {
                        this.props.setCallKeyclick(false)

                        if (DEMO) {
                            this.setState({ showRoomDoorPage: true });
                            return;
                        }
                        this.callForPermission()
                        return;
                    }
                } else {
                    this.props.getDigitalKeySupportedAuthMethods(token, JSON.parse(guestDetails).guestDetails, JSON.parse(guestDetails).reservationNo, (status, message) => {
                        this.setState({ qrScanRequired: this.props.digitalKeySupportedAuthMethods.includes("QRonTV") || this.props.digitalKeySupportedAuthMethods.includes("QRshare") })

                        if (status) {
                            this.props.setLoader(false, "")

                            if (localStorage.getItem("DoorKeyGuideShown") != "true") {
                                this.props.setDoorKeyGuide(true)
                            } else {
                                this.props.setCallKeyclick(false)

                                if (DEMO) {
                                    this.setState({ showRoomDoorPage: true });
                                    return;
                                }
                                this.callForPermission()
                                return;
                            }
                        }
                        else {
                            this.props.setLoader(false, "")
                            this.setState({ showError: true })
                            this.sendGAEvent(EXIT, "");
                        }
                    })
                }
            } else {
                this.props.setLoader(false, "")
                this.setState({ guestDetailsNotFound: true, showError: true })
            }
        } else {

            if (this.getSupportedMethods().length > 0) {
                this.props.setDigitalKeySupportedAuthMethods(this.getSupportedMethods())
                this.setState({ qrScanRequired: this.getSupportedMethods().includes("QRonTV") || this.getSupportedMethods().includes("QRshare") })

                if (localStorage.getItem("DoorKeyGuideShown") != "true") {
                    this.props.setDoorKeyGuide(true)
                } else {
                    this.props.setCallKeyclick(false)

                    if (DEMO) {
                        this.setState({ showRoomDoorPage: true });
                        return;
                    }
                    this.callForPermission()
                    return;
                }
            } else {
                this.props.currentWidget({ widgetType: true });
                this.setState({ showError: true })
                this.sendGAEvent(EXIT, "");
            }
        }
    }

    getSupportedMethods = () => {

        let supportedMethods = []

        if(process.env.REACT_APP_QRSCANENABLE == "true"){
            supportedMethods.push("QRonTV")
        }

        if(process.env.REACT_APP_VERIFY_THROUGH_CMS == "true"){
            supportedMethods.push("FrontdeskAPI")
        }

        console.log("supportedMethods", supportedMethods);
        return supportedMethods
    }

    requestPermissionAsync = (feature, self) => {
        return new Promise((resolve) => {
            runRequestPermission(feature, (status) => {
                resolve(status);
            }, self);
        });
    };

    async checkIOSNotificationPermission() {
    return new Promise((resolve) => {
        const diagnostic = window.cordova.plugins && window.cordova.plugins.diagnostic;
        if (!diagnostic) {
            console.log("Diagnostic plugin not found on this device");
            return resolve(false);
        }

        if (!diagnostic.getRemoteNotificationsAuthorizationStatus) {
            console.log("Notifications module not installed in Diagnostic plugin");
            return resolve(false);
        }

        diagnostic.getRemoteNotificationsAuthorizationStatus((status) => {
            console.log("Current status: " + status);
            if (status === diagnostic.permissionStatus.GRANTED) {
                resolve(true);
            } else {
                diagnostic.requestRemoteNotificationsAuthorization({
                    successCallback: (newStatus) => {
                        console.log("New status: " + newStatus);
                        resolve(newStatus === diagnostic.permissionStatus.GRANTED);
                    },
                    errorCallback: (err) => {
                        console.log("Request failed: " + err);
                        resolve(false);
                    },
                    types: [
                        diagnostic.remoteNotificationType.ALERT,
                        diagnostic.remoteNotificationType.SOUND,
                        diagnostic.remoteNotificationType.BADGE
                    ],
                    omitRegistration: false
                });
            }
        }, (err) => {
            console.log("Error checking permission: " + err);
            resolve(false);
        });
    });
}


    callForPermission = async () => {
        let self = this

        if(window.device){
        if(window.device.platform == "Android"){
            // console.log('Asking for location permission')
            // window.android.checkPermissions();
            let locationPopupShown = localStorage.getItem("locationPopupShown");
            let message = `${this.props.installedAppName} app collects location data to retrieve the digital door key when the app is closed or not in use.`
            let title = "Please allow app to run in background"
            let buttonTitle = "Ok"

            if (window.device.version >= 13 && localStorage.getItem("door_key_type") == "AA" && !localStorage.getItem("door_key_opened")) {
                console.log("[Notification] checking notification permission for android for AA flow");

                const notificationGranted = await this.requestPermissionAsync('NOTIFICATION', self);
                console.log("[Notification] notification permission status:", notificationGranted);

                if (!notificationGranted) {
                    console.log("[Notification] notification permission denied for AA flow");
                    self.sendGAEvent(
                        "NOTIFICATION ACCESS - FAILED",
                        "Door key requires notification to communicate with lock. Please enable notification permission for the app from the phone's Settings.",
                        () => { },
                        { displayError: self.props.t("doorKey_event_error_messages.APP_NOTIFICATION_PERMISSION_FAILED"), errorCode: 'APP_NOTIFICATION_PERMISSION_FAILED' },
                        localStorage.getItem("doorKeyPage")
                    );
                    self.sendGAEvent(EXIT);
                    self.setState({ showNotificationErrScreen: true });
                    self.props.currentWidget({});
                    return;
                }
            }

            if(self.props.installedAndroidSDKVersion <= 7 && !locationPopupShown && navigator.notification && process.env.REACT_APP_BACKGROUND_LOCATION_PERMISSION_ENABLED == "true"){
                console.log('Asking for location permission installedAndroidSDKVersion is ', self.props.installedAndroidSDKVersion)
                await navigator.notification.alert(message, () => {
                    // localStorage.setItem("locationPopupShown", "true")
                    runRequestPermission('LOCATION', self.locationPermissionCallback, self)

                }, title, buttonTitle)
            } else if (self.props.installedAndroidSDKVersion <= 7){
                runRequestPermission('LOCATION', self.locationPermissionCallback, self)
            }else{
                if(self.props.installedAndroidSDKVersion >= 12) runRequestPermission('BLUETOOTH', self.blePermissionCallback, self)
                else self.blePermissionCallback(true, self)
            }  
        } else if(window.device.platform == "iOS") {
            // this.cameraPermissionCallback(true, this)
            // window.cordova.plugins.AssaAbloy.requestLocationPermission()
            // this.props.setLoader(true, "Fetching location...")
            if (localStorage.getItem("door_key_type") === "AA" && !localStorage.getItem("door_key_opened")) {
                console.log("[Notification] checking iOS notification permission for AA flow");
                const granted = await this.checkIOSNotificationPermission();
                console.log("[Notification] iOS notification permission status:", granted);

                if (!granted) {
                    console.log("[Notification] permission denied for AA flow");
                    self.sendGAEvent(
                        "NOTIFICATION ACCESS - FAILED",
                        "Door key requires notification to communicate with lock. Please enable notification permission for the app from the phone's Settings.",
                        () => { },
                        {
                            displayError: self.props.t("doorKey_event_error_messages.APP_NOTIFICATION_PERMISSION_FAILED"),
                            errorCode: "APP_NOTIFICATION_PERMISSION_FAILED"
                        },
                        localStorage.getItem("doorKeyPage")
                    );
                    self.sendGAEvent(EXIT);
                    self.setState({ showNotificationErrScreen: true });
                    self.props.currentWidget({});
                    return;
                }
            }

            this.props.setLoader(true, "Fetching...")
            try {
                // window.plugin.google.maps.LocationService.getMyLocation({enableHighAccuracy: false},(location) => {
                //     console.log("location service",location)
                //     window.runAfterLocationPermissionsCheck(1)
                //     this.props.setLoader(false, "")
                // }, () => {
                //     if(this.errorInIOSLocation){
                //         this.errorInIOSLocation = false
                //         setTimeout(() => {
                //             this.callForPermission()
                //         }, 5000)
                //     }else{
                //         this.props.setLoader(false, "")
                //         window.runAfterLocationPermissionsCheck(0)
                //     }
                // });
                this.props.setLoader(false, "")
                this.cameraPermissionCallback(true, this)
            } catch (error) {
                console.log("error in getting location in room door")
            }
        }
        } else {
            console.log('No android or ios device found')
            this.locationPermissionCallback(true, this)
        }
    }

    locationPermissionCallback = (status, self) => {

        if(!status){
            self.sendGAEvent("LOCATION ACCESS - FAILED", "Door key requires location access to communicate with lock. Please Enable location permission for the app from the phone's Settings.", 
            () => {}, {displayError: self.props.t("doorKey_event_error_messages.APP_LOCATION_PERMISSION_FAILED"), errorCode: 'APP_LOCATION_PERMISSION_FAILED'}, localStorage.getItem("doorKeyPage"))
            self.sendGAEvent(EXIT)
            // self.props.popupOpenClose(true, "Door key requires location access to communicate with lock. Please Enable location permission for the app from the phone's Settings.")
            self.setState({showLocationErrScreen:true});
            self.props.currentWidget({});
            return
        }

        if(window.cordova){
            if(window.device.platform == "Android"){
                if(self.props.installedAndroidSDKVersion >= 12) runRequestPermission('BLUETOOTH', self.blePermissionCallback, self)
                else self.blePermissionCallback(true, self)
            }
            else self.cameraPermissionCallback(true, self)
        } else {
            self.cameraPermissionCallback(true, self)
            console.log("Can't open qr scanner on browser")
        }
    }

    blePermissionCallback(status, self){
        if(status) {
            if(self.state.qrScanRequired) runRequestPermission('CAMERA', self.cameraPermissionCallback, self)
            else self.cameraPermissionCallback(true, self)
        }
        else {
            self.sendGAEvent("BLUETOOTH ACCESS - FAILED", "Door key requires bluetooth to communicate with lock. Please Enable bluetooth permission for the app from the phone's Settings.", 
            () => {}, {displayError: self.props.t("doorKey_event_error_messages.APP_BLUETOOTH_PERMISSION_FAILED"), errorCode: 'APP_BLUETOOTH_PERMISSION_FAILED'}, localStorage.getItem("doorKeyPage"))
            self.sendGAEvent(EXIT)
            // self.props.popupOpenClose(true, "Door key requires bluetooth to communicate with lock. Please Enable bluetooth permission for the app from the phone's Settings.")
            self.setState({showBluetoothErrScreen:true});
            self.props.currentWidget({});
        }
    }



    validateDigitalKeyCallback = (status, message) => {
        console.log('Response for digikey api status:', status)

        clearTimeout(this.apiTimer)
        this.setState({validateKeyResponse: true})

        if(status == undefined) return
        if(booleanConditionCheck(status)) {
            console.log('successfully verified user')
            if(!this.props.loaderClosed) this.props.setDoorKeyNotificaionPage(true);
            localStorage.setItem("FdFlow", true)
            localStorage.setItem('VerifiedUser', true)
            this.props.setLoader(false, null, false )

            const dk_front_desk_verification_success_event_sent = localStorage.getItem("dk_front_desk_verification_success_event_sent") == "true"
            if(!dk_front_desk_verification_success_event_sent)
                this.sendGAEvent("FRONT DESK VERIFICATION - SUCCESS", "", () => localStorage.setItem("dk_front_desk_verification_success_event_sent",true), {"pageName": "FRONT DESK VERIFICATION"})
        } else {
            if(message == "Something went wrong. Please try again."){
                if(window.FireBasePlugin){
                    window.FirebasePlugin.logError("Digital key api gets timeout")
                }
                if(!this.props.loaderClosed) this.props.setSuccessFailPop(true, false, "Something went wrong. Please try again.")
            } else {
                localStorage.setItem('VerifiedUser', false)
                if(!this.props.loaderClosed) this.props.popupOpenClose(true, message)
            }
            this.props.setLoader(false, null, false )
            this.sendGAEvent("FRONT DESK VERIFICATION - FAILED", "Source: FrontDesk Flow > validateDigitalKeyCallback: Error: error while tring to call digitalKey api: " + message, () => {}, {"noOfAttempts": this.noOfAttemptsValidateGuest + 1, "pageName": "FRONT DESK VERIFICATION", displayError: this.props.t("doorKey_event_error_messages.APP_FDK_VALIDATE_API_FAIL"), errorCode: 'APP_FDK_VALIDATE_API_FAIL'})
            this.noOfAttemptsValidateGuest = this.noOfAttemptsValidateGuest + 1
        }
    }

    startTimer = () => {
        this.apiTimer = setTimeout(() => {
            this.cancelValidateKeySource.cancel()
            this.validateKeyCancelToken = axios.CancelToken
            this.cancelValidateKeySource = this.validateKeyCancelToken.source();
            if(!this.state.validateKeyResponse){
                this.validateDigitalKeyCallback(false, "Server timeout. Please try again.")
            }
        }, 10000)
    }


    callGuestValidationAPIs = () => {

        let token = localStorage.getItem("GuestJourneySessionToken")

        try{
            console.log('inside cms verification block')
                console.log('user verified flow')
                this.props.validateDigitalKey(token, this.props.loginGuestDetails[0], this.props.loginGuestDetails[0].reservationNumber, "validateStatus", this.validateDigitalKeyCallback, this.cancelValidateKeySource)
                this.props.setLoader(true, "Verifying guest", true )
                this.startTimer()

        } catch (err) {
            this.props.setLoader(false, null, false)
            console.log("error in calling validation api", err)
            this.sendGAEvent("FRONT DESK VERIFICATION - FAILED", `Source: KeyClick > Frontdesk Flow > callValidationAPIS, Error: error while tring to call digitalKey api: ${err.message}`, () => {}, {"noOfAttempts": this.noOfAttemptsValidateGuest + 1, "pageName": "DOOR KEY REQUEST", displayError: this.props.t("doorKey_event_error_messages.APP_FDK_CALL_VALIDATE_API_FAIL"), errorCode: 'APP_FDK_CALL_VALIDATE_API_FAIL'})
            this.noOfAttemptsValidateGuest = this.noOfAttemptsValidateGuest + 1
            // props.setGoHome(true);
            if(!this.props.loaderClosed) this.props.setSuccessFailPop(true, false, "Something went wrong. Please try again.")
            if(window.FireBasePlugin){
                window.FirebasePlugin.logError("error while tring to call digitalKey api: " + err.message)
            }
        }
    }
    

    cameraPermissionCallback(status, self){
        console.log("permission callback of door key",status);

        // if(localStorage.getItem("VerifiedUser") == "true"){
        //     if(localStorage.getItem("FdFlow") === "true"){
        //         this.callGuestValidationAPIs()
        //     }else{
        //         self.setState({showRoomDoorPage: true})
        //         return
        //     }
        // }

        if(status){
            console.log("inside success of permission callback of door key",status);
            // if(localStorage.getItem("VerifiedUser") == "true"){
            //     self.setState({showRoomDoorPage: true})
            //     return
            // }
            self.setState({showValidationOption: true})
            // self.props.setQRScannerPage(true);
            // self.startScanner();
        } else {
            console.log("inside failure permission callback of door key",status);
            self.sendGAEvent("CAMERA ACCESS - FAILED", "QR scanner needs permission to access camera", () => {}, {displayError: self.props.t("doorKey_event_error_messages.APP_CAMERA_PERMISSION_FAILED"), errorCode: 'APP_CAMERA_PERMISSION_FAILED'})
            self.sendGAEvent(EXIT)
            // self.props.popupOpenClose(true, 'QR scanner needs permission to access camera')
            self.setState({showCameraErrScreen:true});
            self.props.currentWidget({widgetType: true});
        }
    }

    componentDidMount(){
        localStorage.setItem("isDoorKeyInLayout", true)
        console.log("we are here doorkey mounts")
    }


    componentWillUnmount(){
        console.log("we are here doorkey unmounts")
    }

    render() {
        const {t} = this.props

        localStorage.setItem("digitalKeyWidgetName", this.props.widgetInfo.widgetTypeName)
        if(localStorage.getItem("DoorKeyGuideShown") == "true" && this.props.callKeyclick && !this.state.apiCalled){
            console.log("callign key click");
            this.keyClick()
        }
        return (
            <>
                {this.props.navbar ?
                    <a onClick={this.keyClick}
                    className={this.props.selectedHomePage.uniqueKey === this.props.widgetInfo.uniqueKey ? "footButton selected" : "footButton"}>
                        <span class="button-icon">
                            <img src={`${CMSPath}${this.props.widgetInfo.tabIconUrl}`} alt="not found" />
                        </span>
                        <span class="button-label">{this.props.widgetInfo.tabName}</span>
                    </a>
                : <div class={this.props.floatingWidgetRenderType !== "BOTTOM_DOCKED" && "doorkey"} onClick={this.keyClick}>
                    <a class="tile-container" style = {{background: this.props.menuColor.assetBackgroundSelectorColor, marginBottom: 54}}>
                        { this.props.widgetInfo.btnImageUrl ?
                            <span class="button-icon">
                                <img src={`${CMSPath}${this.props.widgetInfo.btnImageUrl}`} />
                            </span> 
                            : <i class="fas fa-key"></i>
                        }
                        {this.props.floatingWidgetRenderType == "BOTTOM_DOCKED" && <span class="button-icon">{this.props.widgetInfo.displayName}</span>}
                    </a>
                </div>}
                
                {this.state.showRoomDoorPage && <HashRouter>
                    <Redirect exact to ={ DEMO ? "/doorKey/demoRoomDoorKey" : "/doorKey/roomDoorKey"}/>
                </HashRouter>}
                {this.state.showValidationOption && <HashRouter>
                    <Redirect exact to ={"/validation/options"}/>
                </HashRouter>}

                {(this.state.showLocationErrScreen || this.state.showCameraErrScreen || this.state.showBluetoothErrScreen || this.state.showNotificationErrScreen || this.state.showError) && 
                <MobileKeyOverlay 
                    overlay="error" 
                    locationErr={this.state.showLocationErrScreen}
                    cameraErr={this.state.showCameraErrScreen} 
                    bluetoothErr={this.state.showBluetoothErrScreen}
                    notificationErr={this.state.showNotificationErrScreen}
                    message={
                        this.state.guestDetailsNotFound
                            ? "Guest details not found. Please try again."
                            : "Unable to get the authentication options, please try again."
                    }
                    // titleMsg={t('door_key.location_access_err')}
                    errorClose = {() => {
                        this.setState({showBluetoothErrScreen: false, showLocationErrScreen: false, showCameraErrScreen: false, showNotificationErrScreen: false, showError: false});
                        this.props.setGoHome(true)
                    }}
                    hideTryAgain={true}/>}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        QRScanPage: state.store.QRScannerPage,
        selectedHomePage: state.store2.currentHomePage,
        showPlaceOrder: state.store2.showPlaceOrder,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        installedAndroidSDKVersion: state.store.installedAndroidSDKVersion,
        CheckedInGuest: state.store.CheckedInGuest,
        DigitalKeyRequestVerified: state.store2.DigitalKeyRequestVerified,
        installedAppName: state.store.installedAppName,
        loaderClosed: state.store2.loaderClosed,
        floatingWidgetRenderType : state.store.home.currentDuration.floatingWidgetRenderType ? state.store.home.currentDuration.floatingWidgetRenderType : null,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        loginGuestDetails: state.store2.loginGuestDetails,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        digitalKeySupportedAuthMethods: state.store2.digitalKeySupportedAuthMethods,
        callKeyclick: state.store2.callKeyclick,
        skipDigitalKeyValidation: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.skipDigitalKeyValidation ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.skipDigitalKeyValidation) : false,
    }
}
export default connect(
    mapStateToProps,
    {
        setShowCustomPopup,
        setDoorKeyNotificaionPage,
        popupOpenClose,
        setQRScannerPage,
        setRegPage,
        setLoadingMass,
        setErrorPopDoorKey,
        validateReservationNo,
        validateDigitalKey,
        setLoader,
        setSuccessFailPop,
        setLoaderClosed,
        sendAnalytics,
        setDoorKeyGuide,
        setLoginRequired,
        setCustomTextForLoginPopup,
        getDigitalKeySupportedAuthMethods,
        currentWidget,
        setGoHome,
        setFeatureNotAvailOnWeb,
        setDigitalKeySupportedAuthMethods,
        setCallKeyclick
    }
)(withTranslation('translations')(DoorKey));